/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React, { useMemo } from "react";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import LandingPageTeaser from "@/src/components/Teaser/LandingPageTeaser";
import FamilyLawTeaserCardSection from "@/src/components/Sections/FamilyLaw/FamilyLawTeaserCardSection/FamilyLawTeaserCardSection";
import PartnerLogoSection from "@/src/components/Sections/Generic/PartnerLogoSection/PartnerLogoSection";
import AttorneySection from "@/src/components/Sections/Generic/AttorneySection/AttorneySection";
import LpFamilyLawAdvoCardMeta from "./AdvoCard/LpFamilyLawAdvoCardMeta";
import LpFamilyLawAragMeta from "./Arag/LpFamilyLawAragMeta";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import HowItWorksSectionFamilyLaw from "@/src/components/Sections/FamilyLaw/HowItWorksSection/HowItWorksSectionFamilyLaw";
import { PARTNER_IRIS } from "@/src/constants/partnerIris";

const getMetaDataByPartner = ({ partner }: { partner: string }) => {
  switch (partner) {
    case PARTNER_IRIS.ADVOCARD:
      return <LpFamilyLawAdvoCardMeta />;
    case PARTNER_IRIS.ARAG:
      return <LpFamilyLawAragMeta />;
    default:
      return null;
  }
};

const LpFamilyLawPartner = ({ partner }: { partner: NonNullable<AbstractCase["acquisitionPartner"]> }) => {
  const { isLoggedIn } = useCustomer();
  const metaData = useMemo(() => getMetaDataByPartner({ partner }), [partner]);

  return (
    <LayoutPublicRoutes minimal={!isLoggedIn} clickableLogo={isLoggedIn}>
      {metaData}
      <LandingPageTeaser headline={"Professionelle Hilfe im Familienrecht"} subheadline={"Wo können wir Sie unterstützen?"} hasTeaserButton={false} />
      {/*here because the cards need to be outsite of the container since their combined width is too much otherwise*/}
      <FamilyLawTeaserCardSection partner={partner} />
      <PartnerLogoSection partnerIri={partner} containerStyle={"settlementContainer"} />
      <HowItWorksSectionFamilyLaw />
      <AttorneySection
        product={"familyLawCase"}
        subheading={"Sie möchten sich professionell und schnell unterstützen lassen? Wir helfen Ihnen - jederzeit und ortsunabhängig!"}
      />
      <FamilyLawTeaserCardSection partner={partner} heading={"Wo können wir Sie unterstützen?"} />
    </LayoutPublicRoutes>
  );
};

export default LpFamilyLawPartner;
